<div class="container" style="margin: 0" fxLayout="column" *ngIf="!showFadProvider && !showErrorPage; else enableFAD;">
  <fal-emergency-alert
    (toggleModal)="toggleModal()"
    (closeClicked)="toggleShowEmergencies()"
    [emergencyHeader]="emergencyHeader ?? ''"
    [emergencyText]="emergencyBody ?? ''"
    [showViewMore]="showViewMore ?? false"
    *ngIf="showEmergencies"
  >
  </fal-emergency-alert>
  <div *ngIf="showBackButton" class="back_button_container">
    <button (click)="backToSearch()" class="back-button">
      <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1L1 8L8 15" stroke="#0071C2" />
      </svg>
      <p><strong>Back to search results</strong></p>
    </button>
  </div>
  <div class="details-container">
    <div class="details-title">
      <h1>{{ location?.name }}</h1>
    </div>

    <div class="details-right">
      <div *ngIf="location?.hospitalVisitorRestrictions?.hasValue()">
        <fal-visitor-info [hospitalVisitorRestrictions]="location?.hospitalVisitorRestrictions"></fal-visitor-info>
      </div>
      <div class="details-description">
        <div class="about" *ngIf="location && location?.aboutLocation">
          <div [ngClass]="{'p2': true, 'active': showMoreActive}">
            <p [innerHTML]="sanitizer.bypassSecurityTrustHtml(location?.aboutLocation ?? '')"></p>
          </div>
          <span (click)="showMoreActive = !showMoreActive" class="show-more"><span>Show {{showMoreActive ? 'less' : 'more'}}</span></span>
        </div>
      </div>
    </div>
    <div class="details-left-rail" *ngIf="isVisibleSideNavigation">
      <fal-side-navigation class="details-left-rail-container" [htmlSideNavigationContent]="htmlSideNavigationContent">
      </fal-side-navigation>
    </div>
    <div class="details-contact-us">
      <fal-contact-us [location]="location"></fal-contact-us>
    </div>
    <div class="details-office-hours">
      <div class="hours-container" *ngIf="locationHourSets.length > 0">
        <fal-hours-card class="fal-hours-card" [headerTitle]="'Location Hours'" [hours]="locationHourSets"></fal-hours-card>
      </div>
      <div class="hours-container" *ngIf="officeHourSets.length > 0">
        <fal-hours-card class="fal-hours-card" [headerTitle]="'Office Hours'" [hours]="officeHourSets"></fal-hours-card>
      </div>
      <fal-more-hours-card
        class="more-hours"
        [labHourSets]="labHourSets"
        [moreHours]="location?.additionalHours!"
        [holidayHours]="holidayHours"
      ></fal-more-hours-card>
    </div>
    <div class="details-map">
      <div class="map-view" *ngIf="location">
        <fal-google-map [locations]="[location!]" [singleMapPin]="'singleMapPin'"></fal-google-map>
      </div>
    </div>
    <div class="details-break"></div>
    <div class="details-hero">
      <div *ngIf="location && heroImageUrl" class="hero-image-container">
        <img class="hero-image" alt="Hero-image" [src]="heroImageUrl" />
      </div>
    </div>
  </div>
  <div *ngIf="location && (services.length > 0)" class="services show-less-content">
    <h2>Services we offer</h2>
    <fal-expander
      [ngClass]="{ 'services-list': !expanderExpanded && services.length > 15}"
      [items]="services"
      [expanderExpanded]="expanderExpanded"
    ></fal-expander>
    <div class="show-more-less" *ngIf="services.length > 15">
      <a tabindex="0" href="javascript:;" (click)="toggleExpanded()">
        {{ expanderExpanded === true ? 'Less' : 'More' }}
        <svg class="more-arrow" [ngClass]="{ 'less-arrow': expanderExpanded === true }" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L6 6L11 1" />
        </svg>
      </a>
    </div>
  </div>
  <fal-provider-card-container
    *ngIf="fadProviders.length !== 0"
    [locationName]="locationName!"
    [providers]="fadProviders"
    [locationId]="enableBlockIT ? locationSlug : locationId"
    [isHospitalBased]="isHospitalBased"
    (ProviderNavigateFAD)="handleProviderNavigateFAD($event)"
  ></fal-provider-card-container>
  <div class="ankle">
    <fal-location-footer></fal-location-footer>
  </div>
  <div class="emergencyAlertText">
    <fal-modal
      #modal
      *ngIf="showModal"
      (closeModal)="showModal = false"
      [emergencyHeader]="emergencyHeader ?? ''"
      [emergencyNotifications]="emergencyBody ?? ''"
    ></fal-modal>
  </div>
</div>
<fal-error-page *ngIf="showErrorPage"></fal-error-page>
<ng-template #enableFAD>
  <fal-fad-components [navigateProviderFAD]="navigateFADModel"></fal-fad-components>
</ng-template>

<dhcl-loading-spinner
  [showSpinner]="showSpinner"
  [fixed]="false"
  [bgColor]="'transparent'"
  *ngIf="showSpinner"
  id="dhclLoadingSpinner"
  class="loading-spinner"
  aria-label="Loading"
  role="alert"
  aria-live="polite"
></dhcl-loading-spinner>
